/* eslint-disable no-undef */

import React from 'react'
import { Box, Paper, makeStyles } from '@material-ui/core'
import parse from 'html-react-parser'

const useStyles = makeStyles(theme => ({
    root: {},
    imageWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: theme.spacing(1.5),
        height: 125
    },
    image: {
        maxWidth: '100%',
        maxHeight: '80%'
    },
    smallImageWrapper: {
        float: 'left',
        marginRight: theme.spacing(1.125),
        width: 35,
        height: 35
    },
    smallImage: {
        maxWidth: '100%',
        maxHeight: '100%'
    },
    title: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: '1.3rem'
    }
}))

function ExtraElement({ imageSrc, smallImageSrc, title, description }) {
    const classes = useStyles()

    return (
        <Box className={classes.wrapper + ' ' + classes.paper} elevation={1}>
            {imageSrc && (
                <Box className={classes.imageWrapper}>
                    <img src={imageSrc} className={classes.image} />
                </Box>
            )}
            {title && (
                <Box mb={0.5} className={classes.title}>
                    {parse(title)}
                </Box>
            )}
            {description && (
                <Box>
                    {smallImageSrc && (
                        <Box className={classes.smallImageWrapper}>
                            <img src={smallImageSrc} className={classes.smallImage} />
                        </Box>
                    )}
                    {parse(description)}
                </Box>
            )}
        </Box>
    )
}

export default ExtraElement
